import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";

export const countMarketingLists = (): Promise<number> => {
    return AxiosClientFactory
        .getInstance()
        .get<number>('/api/marketingLists/count')
        .then((result) => result.data);
};